import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "container mt-4"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "my-5 text-center"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "user mt-2 d-flex justify-content-center" }
const _hoisted_10 = { class: "image" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "info" }
const _hoisted_13 = { class: "d-block" }
const _hoisted_14 = { class: "mb-4 fundo p-2" }
const _hoisted_15 = { class: "d-flex flex-wrap justify-content-center" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { class: "text-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarButtons = _resolveComponent("AvatarButtons")!
  const _component_AvatarOptions = _resolveComponent("AvatarOptions")!
  const _component_AvatarCanvas = _resolveComponent("AvatarCanvas")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "text-center mb-4" }, "Construtor de Avatar!", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.personagens, (personagem) => {
              return (_openBlock(), _createElementBlock("button", {
                key: personagem.nome,
                type: "button",
                class: _normalizeClass(["btn btn-lg btn-primary m-2", { 'btn-danger': $setup.personagemSelecionado === personagem.nome }]),
                onClick: ($event: any) => ($setup.trocarPersonagem(personagem.nome))
              }, _toDisplayString(personagem.label), 11, _hoisted_6))
            }), 128))
          ])
        ]),
        (Object.keys($setup.personagem).length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[2] || (_cache[2] = [
              _createElementVNode("p", null, "Escolha um personagem", -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("img", {
                    src: $setup.personagem.data.rosto,
                    class: "img-circle elevation-2",
                    alt: "User Image"
                  }, null, 8, _hoisted_11)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString($setup.personagem.label), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.abas, (aba) => {
                    return (_openBlock(), _createBlock(_component_AvatarButtons, {
                      key: aba.nome,
                      onClick: ($event: any) => ($setup.abaSelecionada = aba.nome),
                      class: _normalizeClass({ 'border-danger': $setup.abaSelecionada === aba.nome }),
                      label: aba.label,
                      src: `./assets/geral/${aba.nome}.jpeg`
                    }, null, 8, ["onClick", "class", "label", "src"]))
                  }), 128))
                ])
              ])
            ])),
        _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
        ($setup.abaSelecionada)
          ? (_openBlock(), _createBlock(_component_AvatarOptions, {
              key: 2,
              options: $setup.personagem.data[$setup.abaSelecionada],
              modelValue: $setup.selecoes[$setup.abaSelecionada],
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selecoes[$setup.abaSelecionada]) = $event)),
              label: $setup.abas.find(a => a.nome === $setup.abaSelecionada)?.label
            }, null, 8, ["options", "modelValue", "label"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_AvatarCanvas, _mergeProps({ ref: "avatarCanvas" }, $setup.selecoes), null, 16)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", {
            class: "btn btn-lg btn-primary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.saveAvatar && $setup.saveAvatar(...args)))
          }, " Salvar Avatar ")
        ])
      ])
    ])
  ]))
}